import collapsiblePanel from './collapsiblePanel';
import directories from './directories';
import imageSelector from './imageSelector';
import tooltips from './tooltips';
import tree from './tree';
import accordion from './accordion';
import { TStylesObject } from '../../layout';
import notifications from './notifications';
import infoButton from './infoButton';
import filesList from './filesList';
import trees from './trees';
import simpleButton from './simpleButton';
import filteredMenu from './filteredMenu';
import autocompleteInput from './autocompleteInput';
import infoTooltip from './infoTooltip';
import fieldError from './fieldError';
import fieldWarning from './fieldWarning';
import fieldLabelBox from './fieldLabelBox';
import containers from './containers';
/* IMPORT HERE */

const components: TStylesObject = {
  accordion,
  containers,
  collapsiblePanel,
  directories,
  imageSelector,
  tooltips,
  tree,
  notifications,
  infoButton,
  filesList,
  trees,
  simpleButton,
  filteredMenu,
  autocompleteInput,
  infoTooltip,
  fieldError,
  fieldLabelBox,
  fieldWarning,
  /* PREPEND HERE */
};

export default components;
